import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-5339949e")
const _hoisted_1 = { class: "header" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_SearchForm = _resolveComponent("SearchForm")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createVNode(_component_Logo),
    _createVNode(_component_NavBar),
    _createVNode(_component_SearchForm)
  ]))
}